module.exports = __webpack_public_path__ + "static/media/17.079bdf79.JPG";